import { render, staticRenderFns } from "./ChangePW.vue?vue&type=template&id=3d121066&scoped=true&lang=html&"
import script from "./ChangePW.vue?vue&type=script&lang=js&"
export * from "./ChangePW.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d121066",
  null
  
)

export default component.exports